const details = {
    name: "کالای برق کیوان",
    enName: "shop",
    description: "فروش انواع کالای برق ساختمانی و صنعتی | روشنایی | چراغ استخری و آب نما | تابلو برق | استابلایزر",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت طراحی سایت فروشگاهی",
        link: "https://barantm.com/landing/onlineshop-webdesign"
    }
}

export default details;
